import React, { useState, useEffect } from "react";
import { FaExclamationCircle, FaTimes } from "react-icons/fa";
import "./Notification.css";

const Notification = ({ message, type = "error", onClose }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      onClose();
    }, 2500);

    return () => clearTimeout(timer);
  }, [onClose]);

  if (!visible) return null;

  return (
    <div className={`notification ${type}`}>
      <div className="notification-content">
        <FaExclamationCircle className="notification-icon" />
        <span>{message}</span>
      </div>
      <button
        onClick={() => {
          setVisible(false);
          onClose();
        }}
        className="notification-close"
      >
        <FaTimes />
      </button>
    </div>
  );
};

export default Notification;
